import React from 'react'

const SendNotePage = () => {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4">Send Note Page</h1>
      <p>This is a placeholder for the Send Note page.</p>
    </div>
  )
}

export default SendNotePage